// styles
import styled, { css } from 'styled-components';
import { gridSizes, weights } from 'utils/style';

const regularCSS = css`
  font-size: ${gridSizes('M')};
  line-height: 19px;
  margin-top: 0;

  ${({ variant }) =>
    variant === 'label' &&
    css`
      font-size: 14px;
      line-height: ${gridSizes('M')};
      font-weight: ${weights('regular')};
      color: var(--grey500);
      margin-bottom: 0;
    `}
  ${({ variant }) =>
    variant === 'help' &&
    css`
      line-height: ${gridSizes('M')};
      font-weight: ${weights('regular')};
      color: var(--grey500);
      margin-bottom: 0;
    `}
  ${({ variant }) =>
    variant === 'feedback-msg' &&
    css`
      color: var(--grey700);
      font-size: ${gridSizes('M')};
      font-weight: ${weights('regular')};
      line-height: 19px;
      margin: 0;
      margin-bottom: ${gridSizes('M')};
    `}
`;

const Text = styled.p`
  ${regularCSS}
`;

export default Text;
